import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import {
  deleteObjectUseCase,
  updateObjectUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";
import { setDragLock } from "framer-motion";
import DialogSuccess from "./components/DialogSuccess";

class RequestListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    const token = this.view.getToken();
    this.init();
    this.getUser(token);
    return this.getObjects();
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["employee", "coordinator.employee", "attachmentArray"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickEdit(objects) {
    const collection = this.view.getCollectionName();
    const query = {
      where: { id: objects[0].id },
    };
    const response = await this.findObjectUseCase.execute(collection, query);

    if (response && response.length > 0) {
      const object = response[0];

      this.view.setState(
        {
          formData: {
            id: object?.id,
            positionTitle: object?.positionTitle || {},
            slotVacancy: object?.slotVacancy || "",
            qualificationStandard: object?.qualificationStandard || "",
            jobDescription: object?.jobDescription || "",
            deadline: object?.deadline || "",
          },
        },
        () => {
          this.view.onClickAdd(object);
        }
      );
    }
  }

  async onClickDelete(empDetails) {
    dialog.close();
    const object = empDetails;
    const collection = this.view.getCollectionName();

    await deleteObjectUseCase().execute(collection, object.id);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async handleSubmit(formData) {
    dialog.close();
    const collection = this.view.getCollectionName();
    const acl = this.view.getAcl();
    let sendDetails = {};
    if (formData.id !== "") {
      const { password, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId };
    } else {
      const { id, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId, status: "Active" };
    }

    sendDetails.acl = acl;

    await this.upsertUseCase.execute(collection, sendDetails);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async getUser(token) {
    const options = { session: token };

    try {
      const user = await getCurrentUserUseCase().execute(options);
      if (user && typeof user === "object") {
        this.user = user;
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      this.view.navigateTo("/expired");
    }
  }

  validatePassword(newPassword, confirmNewPassword) {
    console.log("newPassword", newPassword);
    console.log("confirmNewPassword", confirmNewPassword);
    if (newPassword !== confirmNewPassword) {
      return "Password must be the same.";
    }

    if (newPassword.length < 8 || newPassword.length > 16) {
      return "Password length must be 8-16 characters.";
    }

    const validation =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]+$/;

    if (!validation.test(newPassword)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one special character, and one number.";
    }

    return null;
  }

  onSubmitPassword(password) {
    dialog.close();
    const user = this.user;
    const { newPassword, confirmNewPassword } = password;

    const errorMessage = this.validatePassword(newPassword, confirmNewPassword);

    if (errorMessage) {
      this.view.showError(errorMessage);
      return;
    }

    user.password = newPassword;
    this.updateUser(user);
  }

  updateUser(user) {
    this.view.showProgress();
    delete user.isMaster;

    updateObjectUseCase()
      .execute("users", user)
      .then((user) => {
        this.view.hideProgress();
        this.user = user;
        this.view.showSuccess("Successfully saved!");
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  async handleResignationAction(object, actionType) {
    const collection = "request";
    const user = this.view.getCurrentUser();
    const updatedObject = { ...object };
    const role = user?.roles?.[0]?.id;

    switch (actionType) {
      case "approve":
        updatedObject.status = "Approved";
        break;

      case "reject":
        updatedObject.status = "Rejected";
        break;
    }

    updatedObject.employee = { id: object.employee?.id };
    updatedObject.coordinator = { id: object.coordinator?.id };

    console.log(object);
    try {
      const resignation = await this.upsertUseCase.execute(
        collection,
        updatedObject
      );

      this.objects = this.objects.map((obj) =>
        obj.id === resignation.id ? resignation : obj
      );

      this.getObjects();

      console.log(updatedObject?.recruiter?.id);
      this.view.setObjects(this.objects);
      this.view.setState({ resignationDetails: updatedObject });
      console.log("Updated Objects:", updatedObject);
      console.log("thisObjects", this.view.objects);
      dialog.close();
      dialog.fire({
        html: (
          <DialogSuccess
            message={`${
              actionType === "approve" ? "Approved" : "Rejected"
            } Successfully.`}
          />
        ),
        footer: false,
      });
    } catch (error) {
      console.error(`Error processing resignation (${actionType}):`, error);
      this.view.showError(error);
    }
  }

  async onSubmitApprove(object) {
    await this.handleResignationAction(object, "approve");
  }

  async onSubmitReject(object) {
    await this.handleResignationAction(object, "reject");
  }
}

export default RequestListPresenter;
